import {myAlertsCustomerInfoDataLoader} from '../../../util/dataLoader';
import { HttpRequest } from '../../../util/http';

export const getUsers = (project: string) => {
    const data: any = { current_project: project };
    const method = 'POST';
    return HttpRequest.fetch('scripts/my_alerts/get_user_list', { data, method })
        .then((res: any) => {
            const users = [];
            try {
                res.users.forEach((user) => {
                    users.push(user);
                });
                return users;
            } catch (e) {
                return [];
            }
        })
}

export const getActionAlertPermissions = (project: string, enabledInputs: string[]) => {
    const data = { resource: project, permission_type: 'ACTIONALERTS' };
    const method = 'POST';
    return HttpRequest.fetch('scripts/admin_action_alerts/permission/get', { data, method })
        .then((res: Permission[]) => {
            try {
                res.forEach((permission) => {
                    if (permission.permission_name === 'Enable Root Cause') { enabledInputs.push('inputRootCause'); }
                    if (permission.permission_name === 'Enable End State') { enabledInputs.push('inputEndState'); }
                });
                return enabledInputs;
            } catch (e) {
                return enabledInputs;
            }
        })
        .catch(() => {
            return enabledInputs;
        })
}

export const getBulkCustomerInfo = (project: string, externalDataReferences: string) => {
  const data = {current_project: project, externalDataReference: externalDataReferences};
  if (externalDataReferences.length) {
    return myAlertsCustomerInfoDataLoader.get(data).then((res: any[]) => {
      return res
    })
      .catch(() => {
        return []
      })
  } else {
    return new Promise<any[]>(() => {
      return []
    })
  }
}
